import { supabase } from './supabase';
import { fetchAll } from './save';

// Which locations a person is responsible for.
//
// This used to be account_reps. A count now hangs off a warehouse, so the
// assignment that decides whose sheet it is hangs off one too. Four screens
// ask the same question - My Counts in three places and the rep dashboard -
// so it is asked in one place.
//
// An empty result is a real answer, not a failure: it means nobody has been
// given a location yet, and the sheets show up under Unassigned instead.
//
// **Both read a page at a time** (the audit after the rebrand, issue 22, 18
// September 2026). One request brings back about a thousand rows and says
// nothing about the rest; the whole site's assignments are 301 today and grow
// with every rep, and past a thousand the locations after it would have shown
// as "Nobody assigned" with nothing to say so.
export async function myWarehouseIds(userId) {
  if (!userId) return [];
  const { data } = await fetchAll(() => supabase
    .from('user_warehouses').select('warehouse_id').eq('user_id', userId)
    .order('warehouse_id'));
  return (data || []).map(w => w.warehouse_id);
}

// Everyone assigned to each location, as { warehouse_id: [rep_id, ...] }.
// A location missing from the map is one nobody covers.
export async function warehouseRepMap() {
  const { data } = await fetchAll(() => supabase
    .from('user_warehouses').select('warehouse_id, user_id')
    .order('warehouse_id').order('user_id'));
  const map = {};
  for (const row of data || []) {
    if (!map[row.warehouse_id]) map[row.warehouse_id] = [];
    map[row.warehouse_id].push(row.user_id);
  }
  return map;
}
